import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxLayout = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2Zm0 2 .001 4H5V5h14ZM5 11h8v8H5v-8Zm10 8v-8h4.001l.001 8H15Z"
	})
});
export default SvgBxLayout;
